export default (state = [], action) => {
  let { type, payload } = action
  switch (type) {
  case 'FRIEND_LIST_SET':
    return payload
  case 'FRIEND_LIST_UPDATE':
    let itemIdex = state.indexOf(i => i.id === payload.id)
    if (itemIdex >= 0) {
      state[itemIdex] = payload
    } else {
      state.push(payload)
    }
    return state
  case 'FRIEND_LIST_DELETE':
    return state.filter(item => item.id != payload)
  case 'LOGOUT':
    return []
  default:
    return state
  }
}
